/**
 * Author: shaochuan.he
 * Date: 2016-11-17
 */

/**
 * 登陆
 */
 var getUA = require('@dp/util-m-ua');
 var environment = getUA();

function toLogin(KNB) {

    // 环境判断
    var UA = (navigator.userAgent).toLowerCase(),
        isAndroid = /android/.test(UA),
        isIOS = /(iphone|ipad)/.test(UA),
        isAppNew = /com\.dianping/.test(UA),
        isAppOld = /efte/.test(UA) || /product\=dpapp/.test(location.search),
        isDPApp = isAppOld || isAppNew,
        isWedApp = /com\.dianping\.wed/.test(UA) || /com\.dianping\.ba\.wed/.test(UA),
        isWeixin = /micromessenger/.test(UA),
        isMTApp = (environment.type == 'mtgroup'),// 符合这两个参数条件,表示是美团的app内嵌页
        isDPM = /dianping\.com/ig.test(location.host) || /51ping/ig.test(location.host);
    var isDP = isDPApp || isDPM,      // 点评app 和 m站
        isApp = isDPApp || isMTApp;   // 点评app 和 美团app 

    var backUrl = location.href;

    if ( isApp ) {      // DpAPP & MtAPP 登录
          KNB.login({
            success: function(user){
              // 登录成功，获取用户信息
              // location.replace(backUrl);
              window.localStorage.setItem('token',user.token)
              if ( isMTApp || isDPApp) {
                //   KNB.closeWebview();
                //   KNB.openWebview({
                //       url: backUrl
                //   });
                //  if (backUrl && backUrl.indexOf('?')!= -1){
                    //  backUrl = backUrl + '&tokenName' + user.token;
                //  }else {
                //      backUrl = backUrl + '?tokenName' + user.token;
                //  }
                 location.href = backUrl;
              } else {
                  location.href = backUrl;
              }

            }
          });
    } else if ( isWeixin ) {      

        if ( isDPM ) {
            // np=2 已经不维护
            location.href = '//m.dianping.com/thirdlogin/auth?aType=3&np=3&rurl='+ encodeURIComponent(backUrl);
        } else {
            location.href = '//i.meituan.com/account/login?backurl=' + encodeURIComponent(backUrl);
        }
       
    } else {  

        if ( isDPM ) {
            location.href = '//m.dianping.com/login?redir=' + encodeURIComponent(backUrl);
        } else {
            location.href = '//i.meituan.com/account/login?backurl=' + encodeURIComponent(backUrl);
        }

    }
};

module.exports = toLogin;



// WEBPACK FOOTER //
// ./src/lib/login.js